/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedblockactiveregistrationhoursinadvance6Inputs */

const en__field_inheritedblockactiveregistrationhoursinadvance6 = /** @type {(inputs: _Field_Inheritedblockactiveregistrationhoursinadvance6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Registration Deadline (inherited)`)
};

const de__field_inheritedblockactiveregistrationhoursinadvance6 = /** @type {(inputs: _Field_Inheritedblockactiveregistrationhoursinadvance6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Anmeldefrist (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "Active Registration Deadline (inherited)" |
*
* @param {_Field_Inheritedblockactiveregistrationhoursinadvance6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedblockactiveregistrationhoursinadvance6 = /** @type {((inputs?: _Field_Inheritedblockactiveregistrationhoursinadvance6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedblockactiveregistrationhoursinadvance6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedblockactiveregistrationhoursinadvance6(inputs)
	return de__field_inheritedblockactiveregistrationhoursinadvance6(inputs)
});
export { _field_inheritedblockactiveregistrationhoursinadvance6 as "_field_inheritedBlockActiveRegistrationHoursInAdvance" }